import { useTranslation } from 'core/i18n';
import { BulkActionsComponent } from 'commons/components';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { BulkDeleteCustomAlarmsComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-bulk-actions/components/bulk-delete-custom-alarms.component';
import { useCustomAlarmsList } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-list/use-custom-alarms-list.hook';
import { BulkActivateCustomAlarmsComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-bulk-actions/components/bulk-activate-custom-alarms.component';
import { BulkDeactivateCustomAlarmsComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-bulk-actions/components/bulk-deactivate-custom-alarms.component';
import { BulkEditCustomAlarmsComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-bulk-actions/components/bulk-edit-custom-alarms.component';
import { useCustomAlarmsNavigation } from 'modules/settings/pods/settings-devices/settings-devices-configuration/hooks/use-custom-alarms-navigation/use-custom-alarms-navigation.hook';

export const CustomAlarmBulkActionsContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        showDeleteConfirmationModal,
        selectedRows,
        setSelectedRows,
        areAllActive,
        areAllInactive,
        showDeactivateConfirmationModal,
        showActivateConfirmationModal,
    } = useCustomAlarmsList();
    const { navigateToEdit } = useCustomAlarmsNavigation();

    if (selectedRows.length === 0) {
        return null;
    }

    const isSingleSelection = selectedRows.length === 1;

    return (
        <BulkActionsComponent
            options={[
                <PocTypography key="bulk_actions_selected" element="span" variant="subtitle1">
                    {t('settings.devices.custom-alarms.bulk-actions.selected', {
                        amount: selectedRows.length,
                    })}
                </PocTypography>,
                <PocButton
                    key="bulk_actions_deselect"
                    variant="tertiary"
                    size="medium"
                    onClick={() => setSelectedRows([])}
                >
                    {t('settings.devices.custom-alarms.bulk-actions.clear-all')}
                </PocButton>,
            ]}
        >
            {isSingleSelection && <BulkEditCustomAlarmsComponent onClick={() => navigateToEdit(selectedRows[0].id)} />}
            {areAllInactive && (
                <BulkActivateCustomAlarmsComponent onClick={() => showActivateConfirmationModal(selectedRows)} />
            )}
            {areAllActive && (
                <BulkDeactivateCustomAlarmsComponent onClick={() => showDeactivateConfirmationModal(selectedRows)} />
            )}
            <BulkDeleteCustomAlarmsComponent onClick={() => showDeleteConfirmationModal(selectedRows)} />
        </BulkActionsComponent>
    );
};
